module.exports = __webpack_public_path__ + "static/media/modeloKit.047d575f.png";